import { motion } from "framer-motion";

interface QuestionClinicProps {
  onNext: () => void;
  onBack: () => void;
  onSelect: (value: string) => void;
  selected: string;
}

const options = [
  { label: "Ja, maar te duur", value: "too-expensive", emoji: "💸", seed: "Dat snappen we helemaal. Kliniekbehandelingen kosten al snel €1.800+ voor een volledige kuur. Het is logisch dat je daar over twijfelt." },
  { label: "Ja, maar te ingrijpend", value: "too-invasive", emoji: "😰", seed: "Heel begrijpelijk. Niemand zit te wachten op naalden of hersteltijd. Je wilt gewoon resultaat, zonder gedoe." },
  { label: "Nee, nooit overwogen", value: "never", emoji: "🙅‍♀️", seed: "Dat horen we vaker. Het goede nieuws: er zijn nu alternatieven die wél de diepere huidlagen bereiken, gewoon vanuit huis." },
];

const QuestionClinic = ({ onNext, onBack, onSelect, selected }: QuestionClinicProps) => {
  const handleSelect = (value: string) => {
    onSelect(value);
  };

  const selectedOption = options.find((o) => o.value === selected);

  return (
    <div>
      <button
        onClick={onBack}
        className="flex items-center gap-2 text-foreground/80 font-sans text-lg md:text-xl mb-5 md:mb-8 hover:text-foreground transition-colors cursor-pointer px-3 py-2 -ml-3 rounded-lg hover:bg-secondary/50"
      >
        <span className="text-xl">←</span> Terug
      </button>

      <div className="text-center">
        <h2 className="text-2xl md:text-4xl font-serif font-medium text-foreground mb-2 leading-tight">
          Heb je ooit een professionele huidbehandeling overwogen?
        </h2>
        <p className="text-foreground/80 font-sans text-lg mb-6 md:mb-10">
          Denk aan kliniek, dermatoloog of beauty-kliniek
        </p>

        <div className="grid gap-2 md:gap-3 mb-4 md:mb-6">
          {options.map((opt, i) => (
            <motion.button
              key={opt.value}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.08 * i }}
              onClick={() => handleSelect(opt.value)}
              className={`quiz-option text-left flex items-center gap-4 ${
                selected === opt.value ? "quiz-option-selected" : ""
              }`}
            >
              <span className="text-2xl flex-shrink-0 w-8 text-center">{opt.emoji}</span>
              <span className="text-foreground font-medium text-lg">{opt.label}</span>
              {selected === opt.value && (
                <motion.span
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  className="inline-block ml-2 text-primary"
                >
                  ✓
                </motion.span>
              )}
            </motion.button>
          ))}
        </div>

        {/* Seeding response — pre-handles price/invasiveness objection */}
        {selectedOption && (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="insight-card text-left mb-5 md:mb-8"
          >
            <p className="text-foreground/80 font-sans text-lg leading-relaxed">
              {selectedOption.seed}
            </p>
          </motion.div>
        )}

        {selected && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            <button onClick={onNext} className="btn-cta">
              Volgende
            </button>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default QuestionClinic;
